// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-loader[data-v-8152417e]{position:absolute;top:120px;left:48%}@media(min-width:1280px){.progress-loader[data-v-8152417e]{top:130px}}", ""]);
// Exports
module.exports = exports;
